function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "black",
  d: "M27.36 26.912c-6.048 6.080-16.64 5.504-22.56-0.416-6.080-6.080-6.4-15.808-0.896-22.24 0.352-0.416 0.672-0.832 1.12-1.088 1.152-0.736 2.72-0.576 3.744 0.416 0.96 0.992 1.12 2.432 0.512 3.584-0.16 0.288-0.288 0.48-0.512 0.704-4.48 4.832-4.64 12.128-0.256 16.512 4.896 4.896 13.024 3.872 17.344-1.088 3.392-3.904 4.544-9.504 2.464-14.432-2.656-6.336-9.76-9.312-16.32-7.104v-0.032c7.552-2.624 15.744 0.768 18.816 8.064 2.272 5.344 1.184 11.36-2.304 15.776-0.352 0.48-0.736 0.928-1.152 1.344z"
});

var SvgSpin = function SvgSpin(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    id: "icon-spin",
    viewBox: "0 0 32 32",
    className: "",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spin.c5c7d677.svg";
export { ForwardRef as ReactComponent };